import { fromJS } from 'immutable';
import PayoutActions from '../actions/PayoutActions';
import { GATEWAY_TYPE, INDIVIDUAL_SOLE_PROPRIETOR, SSN } from '../constants/PayoutConstants';
import { getError } from '../utils/Utils';

export const DEFAULT_STATE = fromJS({
    form: {
        gatewayType: GATEWAY_TYPE.PAYPAL,
        foreignBank: false,
        foreignTax: false,
        businessType: INDIVIDUAL_SOLE_PROPRIETOR,
        taxType: SSN,
        address: { country: 'US' }
    },
    alert: '',
    loading: false,
    error: null
});

const {
    PAYOUT_SAVE,
    PAYOUT_SET_FORM,
    PAYOUT_GET_SUCCESS,
    PAYOUT_SHOW_LOADING,
    PAYOUT_HIDE_LOADING,
    PAYOUT_SHOW_ERROR,
    PAYOUT_HIDE_ERROR,
    PAYOUT_SAVE_SUCCESS,
    PAYOUT_SAVE_INFO_SUCCESS,
    PAYOUT_SAVE_INFO_FAILED,
    PAYOUT_CLEAR_ALERT
} = PayoutActions.TYPES;

export default function(state = DEFAULT_STATE, action) {
    let newState = state;
    switch (action.type) {
        case PAYOUT_SHOW_LOADING: {
            newState = newState.updateIn(['loading'], () => true);
            return newState;
        }

        case PAYOUT_HIDE_LOADING: {
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }

        case PAYOUT_SHOW_ERROR: {
            const error = getError(action.payload);
            newState = newState.updateIn(['error'], () => error);
            return newState;
        }

        case PAYOUT_HIDE_ERROR: {
            newState = newState.updateIn(['error'], () => null);
            return newState;
        }

        case PAYOUT_SET_FORM: {
            const payload = action.payload;
            newState = newState.updateIn(['form'], () => fromJS(payload.form));
            return newState;
        }

        case PAYOUT_GET_SUCCESS: {
            const { payload } = action;
            const targetState = { ...newState.toJS().form, ...payload };
            newState = newState.updateIn(['form'], () => fromJS(targetState));
            return newState;
        }

        case PAYOUT_SAVE: {
            const payload = action.payload;
            newState = newState.updateIn(['action'], () => true);
            newState = newState.updateIn(['payload'], () => payload);
            return newState;
        }

        case PAYOUT_SAVE_SUCCESS: {
            const { payload } = action;
            // res bankAccountNo will be *****
            const targetState = { ...newState.toJS().form, ...payload, bankAccountNo: newState.toJS().form.bankAccountNo || '' };
            newState = newState.updateIn(['form'], () => fromJS(targetState));
            return newState;
        }

        case PAYOUT_SAVE_INFO_SUCCESS: {
            const { payload } = action;
            const targetState = { ...newState.toJS().form, ...payload, bankAccountNo: newState.toJS().form.bankAccountNo || '' };
            newState = newState.updateIn(['form'], () => fromJS(targetState));
            newState = newState.updateIn(['alert'], () => fromJS('epic.esport.success.save'));
            return newState;
        }

        case PAYOUT_SAVE_INFO_FAILED: {
            newState = newState.updateIn(['alert'], () => fromJS('epic.esport.failed.save'));
            return newState;
        }

        case PAYOUT_CLEAR_ALERT: {
            newState = newState.update(['alert'], () => '');
            return newState;
        }

        default:
            return newState;
    }
}
